
export default priorityFlag => {
    const labelByPriorityFlag = {
        ALL: "If ALL User Targets have a Priority Metric Target",
        ANY: "If ANY User Target has a Priority Metric Target",
        NONE: "Do not change any existing Priority Metrics"
    };
    return labelByPriorityFlag[priorityFlag];
};
